import React from 'react';
import { Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { mergeCompanies } from '../../app/slices/companiesSlice';

function MergeCompaniesModal({ show, companies, fallback, onCancel }) {
    const [parent, setParent] = React.useState(null);
    const { t } = useTranslation('CompaniesScreen', { keyPrefix: 'MergeCompanies' });
    const dispatch = useDispatch();

    if (!show) {
        return null;
    }

    const onCloseButtonClick = async () => {
        let children = companies.filter((company) => company.id !== parent).map((company) => company.id);

        let result = await dispatch(mergeCompanies({
            parentId: parent,
            childrenIds: children
        }));

        fallback(!result.hasOwnProperty('error'));
    }

    const onCancelButtonClick = () => {
        onCancel();
    }

    return (
        <div className="fk-modal-overlay">
            <div className="fk-modal" style={{maxWidth: '600px'}}>
                <span className="fk-modal-close" onClick={onCancelButtonClick}>
                    &#10005;
                </span>
                <div className="fk-modal-title">
                    {t('dialogTitle')}
                </div>
                <div className={`fk-modal-body`}>
                    <Grid container spacing={5}>
                        <Grid item md={12}>
                            <RadioGroup
                                value={parent}
                                onChange={(event) => setParent(event.target.value)}
                                sx={{textAlign: 'left'}}
                            >
                                {companies.map((company) => (
                                    <FormControlLabel key={company.id} value={company.id} control={<Radio />} label={company.name} />
                                ))}
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </div>
                <div className="fk-modal-buttons">
                    <Button
                        fullWidth
                        className={`fk-modal-button-normal`}
                        onClick={onCloseButtonClick}
                        disabled={!parent}
                    >
                        {t('merge')}
                    </Button>
                    <Button
                        fullWidth
                        className={`fk-modal-button-danger`}
                        onClick={onCancelButtonClick}
                    >
                        {t('cancel')}
                    </Button>
                </div>
            </div>
        </div>
    );
}


export default MergeCompaniesModal;